import App from "./App.svelte";
import { get, gameState } from "./store";

const app = new App({
  target: document.querySelector(".gameapp"),
  props: {},
});

export default app;
